import { Play } from '@phosphor-icons/react';
import { cn } from '@typedream/ui';
import Image from 'next/image';

import style from './Template.module.css';

interface TemplateProps {
  img: string;
  onHover: () => void;
  onMouseLeave: () => void;
  onSelectTemplate: () => void;
  active?: boolean;
  text?: string;
}

export function Template({
  img,
  onHover,
  onMouseLeave,
  onSelectTemplate,
  active,
  text,
}: TemplateProps) {
  return (
    <div
      className={cn(
        "relative flex items-center justify-center pt-[46.85%] rounded-md border border-solid border-neutral-100 shadow-xl overflow-hidden after:content-[''] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:bg-black after:opacity-0 after:z-[1] hover:after:opacity-20",
        style.template
      )}
      onFocus={() => {
        /** do nothing */
      }}
      onMouseMove={onHover}
      onMouseLeave={onMouseLeave}
    >
      <Image
        src={img}
        alt="Template Preview"
        width={342}
        height={280}
        className="absolute block top-0 left-0 w-full h-full object-cover"
      />
      <button
        type="button"
        className="absolute top-full left-1/2 -translate-x-1/2 translate-y-0 scale-95 bg-white p-2 border-0 rounded-lg z-[2] transition-all duration-200 cursor-pointer"
        style={{
          transitionTimingFunction: 'cubic-bezier(0, 0.97, 0.35, 1.22)',
        }}
        onClick={onSelectTemplate}
      >
        <Play size={20} weight="fill" color="black" className="align-top" />
      </button>
    </div>
  );
}

Template.defaultProps = {
  active: false,
  text: undefined,
};
